var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "component/btn/primary/read_h") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "component/btn/primary/read_h",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#47D5CD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u8A66\\u95B1-copy",
    mask: "url(#mask-2)",
    fontFamily: "PingFangHK-Regular, PingFang HK",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 25
  }, "\u8A66\u95B1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadH);
export default __webpack_public_path__ + "static/media/read_h.1a27ad58add780b9ac6f48821d9deab4.svg";
export { ForwardRef as ReactComponent };